import * as Sentry from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './application/App';
import store from './store';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: __ENV__,
  release: `service-signup-frontend@${__VERSION__}`,
  enabled: !__DEV__,
  // Sentry v11 defaults to collecting more data than v10; keep the restrictive v10 behaviour.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: {
      request: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
      response: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    },
    httpBodies: [],
    urlQueryParams: { deny: ['forwarded', '-ip', 'remote-', 'via', '-user'] },
    genAI: { inputs: false, outputs: false },
    databaseQueryData: false,
    queues: false,
    graphQL: { document: false, variables: false },
  },
});

const container = document.querySelector('.signup-service-container');
if (container !== null) {
  const root = createRoot(container);
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );
}
